// Client-side ETA from measured scan pace: real page counts, no invented percentages.

export interface ProgressSample {
  done: number;
  at: number;
}

/** Keeps samples when `done` moves forward (same `done` twice is ignored). */
export function pushProgressSample(samples: ProgressSample[], done: number, at: number): ProgressSample[] {
  const last = samples.at(-1);
  if (last && last.done >= done) return samples;
  return [...samples, { done, at }];
}

/**
 * Milliseconds left from average pace between the first and last sample. Needs at least one finished page
 * (`done` > 0) and a known total while the scan is still running.
 */
export function estimateRemainingMs(samples: ProgressSample[], done: number, total: number): number | null {
  if (total <= 0 || done <= 0 || done >= total || samples.length < 2) return null;
  const first = samples[0]!;
  const last = samples[samples.length - 1]!;
  const pagesCompleted = last.done - first.done;
  if (pagesCompleted <= 0) return null;
  const elapsed = last.at - first.at;
  if (elapsed <= 0) return null;
  return Math.round((elapsed / pagesCompleted) * (total - done));
}

/** Rough buckets for copy («unos X minutos» / «unos segundos»). */
export function etaDisplay(ms: number): { unit: 'seconds' | 'minutes'; count: number } {
  if (ms < 90_000) {
    const seconds = Math.ceil(ms / 1000);
    return { unit: 'seconds', count: Math.max(5, Math.ceil(seconds / 5) * 5) };
  }
  return { unit: 'minutes', count: Math.max(1, Math.ceil(ms / 60_000)) };
}
